import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import { Row } from './pure/FlexContainer'
import { Ancestor } from '../../models/ApiStructureModel'

const BREADCRUMB_TRUNCATE_LIMIT = 3
interface BreadcrumbsProps {
    node?: object
    ancestors: Ancestor[]
}
export default function Breadcrumbs({ node, ancestors }: BreadcrumbsProps) {
    const [expanded, setExpanded] = useState(false)

    useEffect(() => setExpanded(false), [node])

    let crumbs = ancestors
    if (!expanded && ancestors.length > BREADCRUMB_TRUNCATE_LIMIT)
        crumbs = [...ancestors].splice(ancestors.length - BREADCRUMB_TRUNCATE_LIMIT)
    const isTruncated = crumbs.length < ancestors.length

    return (
        <Row className="structure-breadcrumbs" gap={0.5}>
            {isTruncated && (
                <Row gap={0.5}>
                    <div
                        className="structure-breadcrumbs__segment"
                        onClick={() => setExpanded(true)}
                    >
                        ...
                    </div>
                </Row>
            )}
            {crumbs.map((c, i) => (
                <Row gap={0.5} key={c.id}>
                    {!isTruncated && i === 0 ? '' : '/'}
                    <Link className="structure-breadcrumbs__segment" to={c.link}>
                        {c.name}
                    </Link>
                </Row>
            ))}
        </Row>
    )
}
